import styled from 'styled-components';

export const StyledPatModalSubHeader = styled.div`
  font-size: 1.6rem;
  margin-bottom: 2rem;
`;

export const StyledTokensList = styled.main`
  height: 33rem;
  overflow-y: scroll;
`;

export const StyledMultipleTokensView = styled.div`
  width: 52%;
  margin-right: 2rem;
  font-size: 1.2rem;
`;
